export const RecordEN = {
    "personnelRecord":"Personnel Record",
    "working":"Working",
    "temporaryLeave":"Temporary Leave",
    "resignation":"Resignation",
    "laborContract":"Labor Contract",
    "insurance":"Insurance",
    "competencyAssessment":"Competency Assessment",
    "decision":"Decision",
    "assessmentEmployee":"Assessment Employee",
    "assessmentTemplate":"Assessment Template",
    "assessmentChilds":"Assessment Childs",
    "estimatedIncreasing":"Estimated Increasing",
    "estimatedDecreases":"Estimated Decreases",
    "paymentHistory":"Payment History",
    "dismissalDecision":"Dismissal Decision",
    "terminationOfLaborContract":"Termination Of Labor Contract",
    "salaryDecision":"Salary Decision",
    "rewardDecision":"Reward Decision",
    "disciplineDecision":"Discipline Decision",
    "transferDecision":"Transfer Decision",
    "admissionDecision":"Admission Decision",
    "appointmentDecision":"Appointment Decision",

}